const { getNumericValueWithDecimals } = require('../../analyticUtils');
const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const { createEcommerceEventItemsGA4 } = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');
const { GA4 } = require('../../../../../../config/analytics');
const positionUtils = require('../utils/positionUtils');
const { cartItemListStorage } = require('../../stores/itemList');

/* -------------------------------------------------------------------------- *\
 * CART EVENTS                                                                *
 * -----------                                                                *
 * - Coupon applied error code                                                *
 * - Add product                                                              *
 * - Remove product                                                           *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Coupon applied error code
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.couponAppliedErrorCode, (errorCode) => {
    pushEvent(
      createCustomEventGA4('discount_code_error', [
        ['message', errorCode],
      ]),
    );
  });

  // Add product
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productAddedToCart, (payload) => {
    pushEvent(
      createEcommerceEventGA4('add_to_cart', createEcommerceEventItemsGA4([{
        ...payload.product,
        doubleLookPID: payload.doubleLookPID,
        itemProps: {
          add_to_cart_place: payload.context || GA4.PAGE_TYPES.product,
          index: positionUtils.oneBasedPosition(payload.position) || undefined,
          item_list_id: payload.list,
          searched_term: payload.searchData?.query || undefined,
        },
      }]), {
        currency: gaInfo.currencyCode,
        value: getNumericValueWithDecimals(
          payload.product?.price?.sales?.decimalPrice,
        ),
      }),
    );
  });

  // Remove product
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.productRemovedFromCart, (payload) => {
    pushEvent(
      createEcommerceEventGA4(
        'remove_from_cart',
        createEcommerceEventItemsGA4(
          [payload.product],
          {
            cartItemListStorage,
          },
        ),
        {
          currency: gaInfo.currencyCode,
          value: getNumericValueWithDecimals(
            payload.product?.price?.sales?.decimalPrice,
          ),
        },
      ),
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
